<!-- TODO: reference the correct theme color values -->
<div
  [ngClass]="{ 'custom-input-wrapper': true, 'hide-subscript': hideSubscript }"
>
  @if (screenSize === 'small' && collapsible) { @if (!isExpanded) {
  <app-custom-button
    [icon]="icon"
    buttonType="tertiary-icon"
    [density]="1"
    (click)="toggleSearch()"
  ></app-custom-button>
  } @else {
  <ng-container *ngTemplateOutlet="inputFieldTemplate"></ng-container>
  } } @else {
  <ng-container *ngTemplateOutlet="inputFieldTemplate"></ng-container>
  }
</div>

<ng-template #inputFieldTemplate>
  <mat-form-field
    appearance="outline"
    style="width: 100%"
    [ngClass]="'density-settings-' + density"
    [attr.data-testid]="elementId ? elementId + '_cnt' : null"
  >
    @if(label){
    <mat-label style="color: rgb(33, 36, 39, 0.5)" [attr.data-testid]="elementId ? elementId + '_lbl' : null">{{ label }}</mat-label>
    } @if(type !== 'textarea') {
    <input
      [attr.data-testid]="elementId ? elementId + '_input' : null"
      [required]="required"
      [type]="type"
      matInput
      [readonly]="readonly"
      [placeholder]="placeholder || ''"
      [formControlName]="controlName"
      (blur)="collapsible && collapseSearch(); emitBlurEvent($event)"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [max]="max"
      [min]="min"
      [step]="step"
      (keypress)="emitKeypressEvent($event)"
      (wheel)="type === 'number' && $event.preventDefault()"
    />
    } @else {
    <textarea
      [attr.data-testid]="elementId ? elementId + '_input' : null"
      matInput
      [readonly]="readonly"
      [rows]="rows"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [placeholder]="placeholder || ''"
      [formControlName]="controlName"
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="5"
    >
    </textarea>
    } @if(iconPlacement === 'right' && icon){
    <mat-icon matSuffix style="color: rgb(33, 36, 39, 0.5)">{{
      icon
    }}</mat-icon>
    } @else if(iconPlacement === 'left' && icon){
    <mat-icon matPrefix style="color: rgb(33, 36, 39, 0.5)">{{
      icon
    }}</mat-icon>
    }

    <mat-error [attr.data-testid]="elementId ? elementId + '_err_msg' : null">
      <ng-container [ngTemplateOutlet]="errorsTemplateRef"></ng-container>
      @if (!errorsTemplateRef) {
        <span *ngIf="formGroup.get(controlName!)?.hasError('required')">
            Required field
        </span>
      }
      <span *ngIf="hasOnlyPathTraversalError()">
        {{ formGroup.get(controlName!)?.errors?.['path-traversal']?.error_message }}
      </span>
    </mat-error>

    <span matSuffix class="action-buttons">
      @if (resettable && formGroup.get(controlName!)?.value) {
      <button
        [attr.data-testid]="resetElementId ? resetElementId : (elementId ? elementId + '_btn_reset' : null)"
        mat-icon-button
        (click)="onResetValue()"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
      }

      @if (actionIcon) {
      <button
        [attr.data-testid]="actionElementId ? actionElementId : (elementId ? elementId + '_btn_action' : null)"
        mat-icon-button
        (click)="onActionButtonClick()"
        type="button"
        [matTooltip]="actionText"
      >
        <mat-icon>{{ actionIcon }}</mat-icon>
      </button>
      } @else if (actionText) {
      <button
        mat-button
        class="text-action-btn"
        (click)="onActionButtonClick()"
        type="button"
        [attr.data-testid]="actionElementId ? actionElementId : (elementId ? elementId + '_btn_action' : null)"
      >
        {{ actionText }}
      </button>
      }
    </span>
  </mat-form-field>
</ng-template>
